import { render, staticRenderFns } from "./sponsor_index.vue?vue&type=template&id=d38f88d2&scoped=true&"
import script from "./sponsor_index.vue?vue&type=script&lang=js&"
export * from "./sponsor_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d38f88d2",
  null
  
)

export default component.exports